$(document).ready(function ($) {

    let $mas = $('.posts-wrp').masonry({
        // options
        itemSelector: '.blog-wrp',
        horizontalOrder: true,
        percentPosition: true,
        isAnimated: false
        // gutter: 20

    });
    /*$mas.imagesLoaded().progress(function () {
        $mas.masonry();
        setTimeout(function () {
            $('.blog-wrp').addClass('vis');
            $('#more').addClass('vis');
        }, 400);

    });*/

    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function (e) {
        if ($(this).closest('section.cart').length) {
            return;
        }

        if ($('#agree').is(':checked')) {
            $(this).closest('form').submit();
        } else {
            alert("You must agree with the terms and conditions of sales to check out.");
            e.preventDefault();
            return false;
        }
    });


    $(`#mobile-nav .menu-item--has-dropdown a .icon-arrow-down`).on(`click`, function (e) {
        e.preventDefault();
        $(this).toggleClass(`rotate`);
        $(this).parent().next().stop(true, true).slideToggle();
    })

    $(`#mobile-nav .menu-item--has-dropdown a`).on(`click`, function (e) {
        if ($(e.target).is('a')) {
            if ($(this).attr('href') == '#') {
                e.preventDefault();
                $(this).find('.icon-arrow-down').click();
            }
        }
    })

    let triggered = false;

    function ScrollExecute() {
        let moreButon = $('#more').last(),
            nextUrl = $(moreButon).find('a').attr("href"),
            height = $(window).height();
        if (moreButon.length) {
            if ((($(moreButon).offset().top - $(window).scrollTop()) < height * 3 / 4) && (triggered == false)) {

                triggered = true;
                $.ajax({
                    url: nextUrl,
                    type: 'GET',
                    beforeSend: function () {
                        moreButon.remove();
                    },
                    success: function (data) {
                        let posts = $(data).find('.posts-wrp').html();

                        $('.posts-wrp').append(posts);
                        $('.blog-posts .container').append($(data).find('#more'));
                        $mas.imagesLoaded().progress(function () {
                            $mas.masonry("reloadItems").masonry("layout");
                            setTimeout(function () {
                                $('.blog-wrp').addClass('vis');
                                $('#more').addClass('vis');
                            }, 400);
                        });

                        triggered = false;
                    }
                })

            }
        }
    }

    if (!$("body").hasClass("template-index")) {
        $(window).scroll(function () {
            if ($('.blog-posts').length) {
                ScrollExecute();
            }
            if ($(window).scrollTop() > 100) {
                $("#header").addClass("tr-bg");
            } else {
                $("#header").removeClass("tr-bg");
            }
        });
    } else {
        $("#header").addClass("tr-bg");
    }

    var hide_discount_popup = $.cookie('hide_discount_popup');
    if (typeof hide_discount_popup == 'undefined') {
        $('#discount_popup').show();
    }

    $(document).on('click', '#discount_popup .ds_close', function () {
        $.cookie('hide_discount_popup', '1');
        $('#discount_popup').hide();
    });

    $('#filter .filter p > span').on('click', function () {
        $(this).parents('li.filter').find('input').click();
    });

    $('#filter li.filter input').on('change', function () {

        let targetElements = [],
            $products = $('.products-holder.filter-holder .single-product');

        if (!$('#filter li.filter input:checked').length) {
            $('.cats-rows').removeClass('empty');
            let i = 1;

            $products.each(function () {
                let countClass = (i % 2 === 0) ? 'even' : 'odd';
                $(this).removeClass('odd').removeClass('even');
                $(this).addClass(countClass).attr('data-num', i).show();
                i++;
            })
        } else {
            $products.removeClass('odd').removeClass('even').hide();
            $('#filter li.filter input:checked').each(function () {
                //targetElements.push($(this).data('prods'));
                targetElements = targetElements.concat($(this).data('prods'));
            });

            // targetElements = intersect(targetElements);
            targetElements = Array.from(new Set(targetElements))
            targetElements.forEach(function (el) {
                $(`#product-${el}`).show();
            })

            if ($('.products-holder .single-product:visible').length) {
                $('.cats-rows').removeClass('empty');
                let i = 1;
                $('.products-holder .single-product:visible').each(function () {
                    let countClass = (i % 2 === 0) ? 'even' : 'odd';
                    $(this).removeClass('odd').removeClass('even');
                    $(this).addClass(countClass).attr('data-num', i).show();
                    i++;
                })
            } else {
                $('.cats-rows').addClass('empty');
            }
        }
    });

    function intersect(arrays) {
        if (0 === arrays.length) {
            return [];
        }
        return arrays.reduce((intersection, array) => {
            return intersection.filter(intersectedItem => array.some(item => intersectedItem === item));
        }, arrays[0]);
    }

    $("#header .menu").on('click', function (e) {
        $("#open-nav").slideDown()
    })

    $("#open-nav .close-menu").on('click', function (e) {
        $("#open-nav").slideUp()
    })

    $(".product-single section.description span.show_more").on('click', function (e) {
        if ($(this).hasClass('see_less')) {
            $(this).text("View full ingredient list")
            $(".show_more_wrapper p.hidden").slideUp()
            $(this).removeClass('see_less')
        } else {
            $(this).text("See less")
            $(".show_more_wrapper p.hidden").slideDown().show()
            $(this).addClass('see_less')
        }
    })

    new Swiper('.swiper-related', {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 28,
                centeredSlides: false
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    $("#filter").submit(function (e) {
        e.preventDefault()
        var type = $("#filter_type").val()
        var brand = $("#filter_brand").val()

        var current_url = "/collections/shop-medical-grade";
        $.cookie('filter_type', type);
        $.cookie('filter_brand', brand);
        if (type != "" && brand == "") {
            window.location.href = current_url + '/+' + "type:" + type
        } else if (type == "" && brand != "") {
            window.location.href = current_url + '/+' + "brand:" + brand
        } else if (type == "" && brand == "") {
            window.location.href = current_url
        } else {
            window.location.href = current_url + '/+' + "type:" + type + "+" + "brand:" + brand
        }
    });
    if ($.cookie('filter_type')) {
        $("form#filter #filter_type").val($.cookie('filter_type'))
    }
    if ($.cookie('filter_brand')) {
        $("form#filter #filter_brand").val($.cookie('filter_brand'))
    }

    // filter_shop_page
    $("#filter_shop_page").submit(function (e) {
        e.preventDefault()
        let selectType = $("#filter_type").val(),
            selectBrand = $("#filter_brand").val()

        $("#shop .blocks .item").each(function (ll) {
            let dataBrand = $(this).attr('data-brand'),
                dataType = $(this).attr('data-type')
            $.cookie('filter_shop_type', selectType)
            $.cookie('filter_shop_brand', selectBrand)

            if (selectType !== '' && selectBrand === '') { // type ka brand chka DONE!!!
                this.style.display = 'none'
                if (dataType) {
                    if (dataType.includes(selectType)) {
                        this.style.display = 'flex'
                    }
                }
            } else if (selectType === '' && selectBrand !== '') { // type chka brand ka DONE!!!
                this.style.display = 'none'
                if (selectBrand === dataBrand) {
                    this.style.display = 'flex'
                }
            } else if (selectType !== '' && selectBrand !== '') { // type ka brand ka
                this.style.display = 'none'
                if (dataType) {
                    if (dataType.includes(selectType) && selectBrand === dataBrand) {
                        this.style.display = 'flex'
                    }
                }
            } else {
                this.style.display = 'flex'
            }
        })
        if ($("#shop .shop-section-rvl .blocks").height() === 0) {
            $("#shop .shop-section-rvl .title").hide()
        } else {
            $("#shop .shop-section-rvl .title").show()
        }
        if ($("#shop .shop-section-medical .blocks").height() === 0) {
            $("#shop .shop-section-medical .title").hide()
        } else {
            $("#shop .shop-section-medical .title").show()
        }
    })

    if ($('.products-wrp').length) {
        $('.products-wrp').each(function () {
            let rightArrow = $('.arrow-next', this);
            let leftArrow = $('.arrow-prev', this);
            new Swiper(this, {
                slidesPerView: 5,
                spaceBetween: 20,
                freeMode: true,
                watchOverflow: true,
                mousewheel: true,
                navigation: {
                    nextEl: rightArrow[0],
                    prevEl: leftArrow[0],
                },
                breakpoints: {
                    360: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 5,
                    },
                }
            });
        });
    }

    /*$(".custom-select-wrapper").click(function(e) {
        $(this).find('.custom-select').toggleClass('open')
    })*/
    for (const dropdown of document.querySelectorAll(".custom-select-wrapper")) {
        dropdown.addEventListener('click', function (e) {
            if (!$(e.target).parent().hasClass('service')) {
                this.querySelector('.custom-select').classList.toggle('open');
            }
        })
    }

    var location = '',
        location_val = '',
        locationConcierge = '',
        locationConcierge_val = '',
        reasonConcierge = '',
        reasonConcierge_val = '',
        app = '',
        app_val = '',
        service = '',
        service_val = '';
    for (const option of document.querySelectorAll(".custom-option")) {
        option.addEventListener('click', function () {
            if (!this.classList.contains('coming_soon')) {

                if ($(this).parent().hasClass('type')) {
                    $(".custom-options.type .custom-option").removeClass('selected')
                    $(this).addClass('selected')
                    /*if( $(this).data('value') == "new_patient" ) {
                        $(".first_step_form .location span.custom-option").each(function(key, val) {
                            if( $(val).data('value') == "manhattan" ) {
                                //$(val).addClass('selected')
                            } else {
                                $(val).hide()
                            }
                        })
                        $(".patients").slideUp()
                        $(".services").slideDown({
                            start: function () {
                                if( $( window ).width() > 767 ) {
                                    $(this).css({
                                        display: "flex"
                                    })
                                } else {
                                    $(this).css({
                                        display: "block"
                                    })
                                }
                            }
                        })
                    } else*/
                    if ($(this).data('value') == "wait_patient") {
                        $(".patients").slideUp()
                        $(".first_step_wrap").hide()
                        $(".first_step_form").hide()
                        $(".second_step_form").show()
                        $(".second_step_wrap").removeClass('inactive').find('h2').text('Personal information')
                        $(".second_step_form .koko.witelist").removeClass('hide')
                        $(".services").slideDown({
                            start: function () {
                                if ($(window).width() > 767) {
                                    $(this).css({
                                        display: "flex"
                                    })
                                } else {
                                    $(this).css({
                                        display: "block"
                                    })
                                }
                            }
                        })
                    } else if ($(this).data('value') == "old_patient") {
                        //$(".patients").slideUp()
                        $("#established_trigger").trigger('click')
                    }
                } else {
                    if ($(this).parent().hasClass('service')) {
                        if ($(this).hasClass('selected')) {
                            $(this).removeClass('selected')
                            $(this).closest('.custom-select').find('.custom-select__trigger span').text('')
                            for (var service_text of document.querySelectorAll(".custom-options.service .custom-option.selected")) {
                                $(this).closest('.custom-select').find('.custom-select__trigger span').append($(service_text).text() + ", ")
                            }
                        } else {
                            if ($(this).data('value') != "") {
                                this.classList.add('selected');
                                $(this).closest('.custom-select').find('.custom-select__trigger span').text('')
                                for (var service_text of document.querySelectorAll(".custom-options.service .custom-option.selected")) {
                                    $(this).closest('.custom-select').find('.custom-select__trigger span').append($(service_text).text() + ", ")
                                }
                            }
                        }
                    } else {
                        this.parentNode.querySelector('.custom-option.selected').classList.remove('selected');
                        this.closest('.custom-select').querySelector('.custom-select__trigger span').textContent = this.textContent;
                        this.classList.add('selected');
                    }

                    if ($(this).parent().hasClass('locationConcierge')) {
                        locationConcierge = $(this).data('value')
                        locationConcierge_val = this.textContent
                        if (reasonConcierge != "" && locationConcierge != "") {
                            $("#concierge_new_patient .form button").attr('disabled', false)
                        } else {
                            $("#concierge_new_patient .form button").attr('disabled', true)
                        }
                    }
                    if ($(this).parent().hasClass('reasonConcierge')) {
                        reasonConcierge = $(this).data('value')
                        reasonConcierge_val = this.textContent
                        if (reasonConcierge != "" && locationConcierge != "") {
                            $("#concierge_new_patient .form button").attr('disabled', false)
                        } else {
                            $("#concierge_new_patient .form button").attr('disabled', true)
                        }
                    }


                    if ($(this).parent().hasClass('location')) {
                        location = $(this).data('value')
                        location_val = this.textContent
                        if (location == "manhattan-old" || location == "hamptons") {
                            $("#__ezderm_online_scheduling_widget__").hide()
                            $(".app_wrapper").show()
                            $(".service_wrapper").show()
                            $(".next-btn").show()
                            //$(".custom-options.app").find('span.manhattan').removeClass('none')
                            $(".custom-select.app").find('.custom-select__trigger span').text("Cosmetic")
                            if ($(".custom-options.app .custom-option").hasClass('all')) {
                                $(".custom-options.app .custom-option").addClass('selected')
                            }
                            $(".custom-options.app .custom-option.first").removeClass('selected')
                            /*app = $(".custom-options.app .custom-option.selected").data('value')
                            app_val = $(".custom-options.app .custom-option.selected").text()*/
                            app = "cosmetic"
                            app_val = "Cosmetic"
                            if (location == "manhattan") {
                                if ($(".type_of_patient .custom-options.type .selected").data('value') == "old_patient") {
                                    $(".second_step_wrap").show()
                                }
                            }
                            if (location == "hamptons") {
                                if ($(".type_of_patient .custom-options.type .selected").data('value') == "old_patient") {
                                    $("#__ezderm_online_scheduling_widget__").show()
                                    $(".app_wrapper").hide()
                                    $(".service_wrapper").hide()
                                    $(".second_step_wrap").hide()
                                    $(".next-btn").hide()
                                }
                            }
                        } else if (location == "") {
                            $("#__ezderm_online_scheduling_widget__").hide()
                            $(".app_wrapper").show()
                            $(".service_wrapper").show()
                            $(".next-btn").show()
                            $(".custom-select.app").find('.custom-select__trigger span').text("Please select")
                            if ($(".custom-options.app").find('span').data("value") == "") {
                                $(".custom-options.app .custom-option").removeClass('selected')
                                $(".custom-options.app .custom-option.first").addClass('selected')
                            }
                            $(".custom-options.app .custom-option.first").removeClass('selected')
                        } else if (location == "greenwich") {
                            //window.location.href = "https://rvlskincare.com/pages/rvl-skincare-pc"
                            if ($(".type_of_patient .custom-options.type .selected").data('value') == "old_patient") {
                                $("#__ezderm_online_scheduling_widget__").show()
                                $(".app_wrapper").hide()
                                $(".second_step_wrap").hide()
                                $(".service_wrapper").hide()
                                $(".next-btn").hide()
                            }
                        } else if (location == "aspen") {
                            if ($(this).closest('.witelist').hasClass('hide')) {
                                $("#__ezderm_online_scheduling_widget__").show()
                                $(".next-btn").hide()
                                $(".app_wrapper").hide()
                                $(".service_wrapper").hide()
                            }
                            if ($(".type_of_patient .custom-options.type .selected").data('value') == "old_patient") {
                                $("#__ezderm_online_scheduling_widget__").show()
                                $(".app_wrapper").hide()
                                $(".second_step_wrap").hide()
                                $(".service_wrapper").hide()
                                $(".next-btn").hide()
                            }
                        }
                        /*else {
                            $(".custom-options.app").find('span.manhattan').addClass('none')
                            $(".custom-options.app").find('span.all').removeClass('none')
                        }*/
                    } else if ($(this).parent().hasClass('app')) {
                        app = $(this).data('value')
                        app_val = this.textContent
                        /*if(location == "manhattan" && app == "medical") {
                            $(".service_wrapper").hide()
                            $(".first_step_form button").hide()
                            $("#popup_trigger").trigger('click')
                        } else {*/
                        $(".first_step_form button").show()
                        $(".service_wrapper").show()
                        //}
                    } else if ($(this).parent().hasClass('service')) {
                        service = $(this).data('value')
                        service_val = this.textContent
                    }
                }


                if (location != "" && app != "" && service != "") {
                    $(".book-in-person-content .first_step_form button.next-btn").removeClass('inactive').addClass('active').removeAttr('disabled')
                } else {
                    $(".book-in-person-content .first_step_form button.next-btn").removeClass('active').addClass('inactive').attr('disabled', true)
                }
            }

        })
    }

    window.addEventListener('click', function (e) {
        for (const select of document.querySelectorAll('.custom-select')) {
            if (!select.contains(e.target) && !$(e.target).parent().hasClass('service')) {
                select.classList.remove('open');
            }
        }
    });


    $(document).on('click', ".first_step_form .next-btn.active", function (e) {
        $(".book-in-person-content .first_step_form").slideUp()
        $(".book-in-person-content .second_step_form").slideDown()
        $(".book-in-person-content .first_step_wrap").addClass("inactive")
        $(".book-in-person-content .second_step_wrap").removeClass("inactive")
        $(".book-in-person-content span.first_edit").show()
        $(".book-in-person-content p.first_step").show()
        var show_service_txt = ''
        for (var service_text of document.querySelectorAll(".custom-options.service .custom-option.selected")) {
            show_service_txt += $(service_text).text() + ", "
        }
        $(".book-in-person-content p.first_step").text(app_val + " appointment for " + show_service_txt + " at the " + location_val + " location")
    })

    $(".book-in-person-content .first_edit").click(function (e) {
        $(".book-in-person-content .second_step_form").slideUp()
        $(".book-in-person-content .three_step_form").slideUp()
        if ($(window).width() > 767) {
            $(".book-in-person-content .right-side .first_step_form").slideDown()
        } else {
            $(".book-in-person-content .left-side .first_step_form").slideDown()
        }
        $(".book-in-person-content .first_step_wrap").removeClass("inactive")
        $(".book-in-person-content .second_step_wrap").addClass("inactive")
    })

    $('.single-date-field').mask('00/00/0000');
    $("#phone").mask("(999) 999-9999");

    jQuery.validator.addMethod("fullname", function (value, element) {
        if (/^([a-zA-Z]{2,}\s[a-zA-z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)/.test(value)) {
            return true;
        } else {
            return false;
        }
    }, 'Please enter your full name.');

    $("#book_in_person").validate({
        rules: {
            Full_Name: { // Corresponds to the `name` attribute
                required: true,
                fullname: true // Attaches the new method to the element
            },
            email_field: {
                required: true,
                email: true
            }
        },
        submitHandler: function (form, e) {
            e.preventDefault();
        },
    });


    $("#book_in_person input").on("keyup keydown focus", function (e) {
        let full_name = $("#full-name").val(),
            email_field = $("#email_field").val(),
            phone_number = $("#phone").val(),
            birthday = $("#birthday").val(),
            location = false

        $.cookie('full_name', full_name);
        $.cookie('email_field', email_field);
        $.cookie('phone_number', phone_number);
        $.cookie('birthday', birthday);

        if ($("#book_in_person .koko.witelist").hasClass("hide")) {
            location = true
        } else {
            if ($(".koko.witelist .location span.selected").attr('data-value') != "") {
                location = true
            } else {
                location = false
            }
        }
        if ($("#full-name").hasClass('valid') && $("#email_field").hasClass('valid') && phone_number.length > 6 && birthday.length == 10 && location) {
            $(".book-in-person-content .second_step_form button.next-btn").removeClass('inactive').addClass('active').removeAttr('disabled')
        } else {
            $(".book-in-person-content .second_step_form button.next-btn").removeClass('active').addClass('inactive').attr('disabled', true)
        }
    })

    if (!$("#book_in_person .koko.witelist").hasClass("hide")) {
        $(".book-in-person-content .second_step_form button.next-btn").removeClass('inactive').addClass('active').removeAttr('disabled')
    }

    $(document).on('click', ".second_step_form .next-btn.active", function (e) {
        if ($.cookie('full_name') != "" && $.cookie('email_field') != "" && $.cookie('phone_number') != "" && $.cookie('birthday') != "") {
            $(".book-in-person-content .second_step_wrap").addClass("inactive")
            $(".book-in-person-content span.second_edit").show()
            $(".book-in-person-content .second_step_form").slideUp()
            $(".book-in-person-content .three_step_form").slideDown()
            if (!$(".koko.witelist").hasClass('hide')) {
                $.cookie('white_loc', $(".koko.witelist .custom-option.selected.checked").text());
                $(".book-in-person-content p.second_step").html("<div>For " + $.cookie('full_name') + "<br>" + $.cookie('email_field') + "<br>" + $.cookie('phone_number') + "<br>Date of birth - " + $.cookie('birthday') + "<br>Location - " + $.cookie('white_loc') + "</div>")
            } else {
                $(".book-in-person-content p.second_step").html("<div>For " + $.cookie('full_name') + "<br>" + $.cookie('email_field') + "<br>" + $.cookie('phone_number') + "<br>Date of birth - " + $.cookie('birthday') + "</div>")
            }
        } else {
            $(this).removeClass('active').addClass('inactive').attr('disabled', true)
        }
    })

    $(document).on('click', ".three_step_form span, #book_in_person span, #book_in_person_pc span", function (e) {

        var location = false
        if ($(this).closest('.koko.witelist').hasClass('hide')) {
            location = true
        } else {
            if ($(".koko.witelist .location span.selected").attr('data-value') !== "") {
                location = true
            } else {
                location = false
            }
        }

        if ($(this).hasClass('checked')) {
            $(this).removeClass('checked')
        } else {
            $(this).addClass('checked')
        }
        //if ($(".koko.witelist .location span.selected").attr('data-value') !== "") {
        // check input valid ----
        if ($("#full-name").hasClass('valid') && $("#email_field").hasClass('valid') && $("#phone").val().length > 6 && $("#birthday").val().length == 10 && location) {
            $("#book_in_person button.next-btn").removeClass('inactive').addClass('active').removeAttr('disabled')
        }
        //}

        if ($("span.check").hasClass('checked')) {
            $(".book-in-person-content .three_step_form button.next-btn").removeClass('inactive').addClass('active').removeAttr('disabled')
            if ($("#full-name").hasClass('valid') && $("#email_field").hasClass('valid') && $("#phone").val() != "" && $("#birthday").val() != "") {
                $("#send_email_greenwich").removeClass('inactive').addClass('active').removeAttr('disabled')
            }
        } else {
            $(".book-in-person-content .three_step_form button.next-btn").removeClass('active').addClass('inactive').attr('disabled', true)
            $("#send_email_greenwich").removeClass('active').addClass('inactive').attr('disabled', true)
        }
    })

    $(".book-in-person-content .second_edit").click(function (e) {
        $(".book-in-person-content .second_step_form").slideDown()
        $(".book-in-person-content .first_step_form").slideUp()
        $(".book-in-person-content .three_step_form").slideUp()
        $(".book-in-person-content .first_step_wrap").addClass("inactive")
        $(".book-in-person-content .second_step_wrap").removeClass("inactive")
    })

    $(".shop-section-rvl .blocks .item").click(function (e) {
        let shop_pr_url = $(this).find('.details h3 a').attr('href')
        if (shop_pr_url != undefined) {
            window.location.href = "https://rvlskincare.com" + shop_pr_url;
        }
    })

    $(".shopping-wrapper .block").click(function (e) {
        let shop_pr_url = $(this).find('.txt a').attr('href')
        if (shop_pr_url != undefined) {
            window.location.href = "https://rvlskincare.com" + shop_pr_url;
        }
    })

    // get url param by ninja
    function getQueryStringParameters() {
        var parameters = {}, hash;
        var q = document.URL.split('?')[1];
        if (q != undefined) {
            q = q.split('&');
            for (var i = 0; i < q.length; i++) {
                hash = q[i].split('=');
                parameters[hash[0]] = hash[1].replaceAll('+', ' ');
            }
        }
        return parameters;
    }

    function isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    function addQueryStringToPortalLink() {
        var q = document.URL.split('?')[1];
        if (q != undefined) {
            const buttonLinkObj =$('#shopify-section-established-contract-2 section.cont_form form a.btn-membership');
            let linkHref = buttonLinkObj.attr('href') + '?' + q;
            buttonLinkObj.attr('href', linkHref);
        }
        
    }

    var amountContract = ""
    var parameters = getQueryStringParameters();
    var waitList = false
    if (isEmpty(parameters) == false) {
        // add get params to the portal link
        addQueryStringToPortalLink();

        $.each(parameters, function (key, value) {

            if (key == "amount" && value != "") {
                let txt1 = $("#shopify-section-established-contract").html(),
                    txt2 = $("#shopify-section-established-contract-2 .member").html()
                $("#shopify-section-established-contract").html(txt1.replaceAll('{amount}', value))
                $("#shopify-section-established-contract-2 .member").html(txt2.replaceAll('{amount}', value))
                amountContract = value
            }
            if (key == "amount_discounted" && value != "") {
                let txt1 = $("#shopify-section-established-contract").html(),
                    txt2 = $("#shopify-section-established-contract-2 .member").html()
                $("#shopify-section-established-contract").html(txt1.replaceAll('{amount_discounted}', value))
                $("#shopify-section-established-contract-2 .member").html(txt2.replaceAll('{amount_discounted}', value))
            }
            if (key == "amount_text" && value != "") {
                $("#shopify-section-established-contract-2 .member").html($("#shopify-section-established-contract-2 .member").html().replaceAll('{amount_text}', value.replaceAll('%20', ' ')))
            }

            if ((key == "waitlist" && value == "true") || (key == "requestPassword" && value == "true")) {
                waitList = true
                $(".patients, .first_step_wrap, .first_step_form").hide()
                $(".patients .type_of_patient .first").removeClass('selected')
                $(".patients .type_of_patient .custom-options .custom-option[data-value='wait_patient']").addClass('selected')
                $(".second_step_wrap").removeClass('inactive')
                $("h2.information").text("Personal information")
                $(".services").css({"display": "flex"})
                $(".second_step_form").show()
                $(".second_step_form .witelist").removeClass('hide')
                $(".second_step_form button.next-btn").addClass("inactive")
            }

            if (key == "requestPassword" && value == "true") {
                $(".last_see").removeClass('hide')
            }

            if (key == "fullName" && value != "") {

                $("#full_name").text(value)
                $(document).find("#full_name_input").val(value)
            }

            if (key === "amount_text" && value !== "") {
                let today = new Date(),
                    month = new Date().toLocaleString('en-EN', {month: 'long'}),
                    date = month + ' ' + today.getDate() + ", " + today.getFullYear()
                $("#sendMemberForm #date").val(date)
                // input.date
            }

            if (key == "redirect_uri" && value !== "") {
                $("form#sendMemberForm").submit(function (e) {
                    e.preventDefault();
                  console.log("form#sendMemberForm")
                    window.location.href = value;
                })
            }

        });
    }
    // END query params

    $("#send_email").click(function (e) {
        if ($(window).width() > 767) {
            let location = $(".right-side .location .selected").text()
        } else {
            let location = $(".left-side .location .selected").text()
        }

        let type = $(".custom-options.type .selected").data('value')

        let app = $(".custom-options.app .selected").text()
        let service = ''
        $(".custom-options.service .selected").each(function (index, val) {
            service += $(val).text() + ", "
        })
        let full_name = $("#full-name").val()
        let email_field = $("#email_field").val()
        let phone = $("#phone").val()
        let birthday = $("#birthday").val()
        let last_see = $("#last_see").val()

        $.ajax({
            type: "POST",
            url: "https://app-web.rvlskincare.com",
            data: {
                type, location, app, service,
                full_name, email_field, phone, birthday, last_see
            },
            success: function (res) {
                if (res == "error") {
                    $("#send_email").show()
                    $(".success-msg").text("")
                } else {
                    $("#send_email").hide()
                    $(".success-msg").text("Thank You")
                }
            },
            error: function () {
                $('.error-message').show();
            }
        });
    })

    $("#book_in_person_pc").submit(function (e) {
        e.preventDefault()
        let location = "Greenwich, CT";
        let app = "Cosmetic";
        let full_name = $("#full-name").val()
        let email_field = $("#email_field").val()
        let phone = $("#phone").val()
        let birthday = $("#birthday").val()

        if (full_name != "" && email_field != "" && phone != "" && birthday != "") {
            $.ajax({
                type: "POST",
                url: "https://app-web.rvlskincare.com",
                data: {
                    location, app, action: 'greenwich',
                    full_name, email_field, phone, birthday
                },
                success: function (res) {
                    if (res == "error") {
                        $("#send_email_greenwich").show()
                        $(".success-msg").text("")
                    } else {
                        $("#send_email_greenwich").hide()
                        $(".success-msg").text("Thank You")
                    }
                },
                error: function () {
                    $('.error-message').show();
                }
            });
        }
    })

    // about
    new Swiper('.media-items-container', {
        slidesPerView: "auto",
        spaceBetween: 30,
        centeredSlides: false,
        navigation: {
            nextEl: '.arrow-next',
            prevEl: '.arrow-prev',
        },
    });

    new Swiper('.media-press-items-container', {
        slidesPerView: 2,
        spaceBetween: 30,
        centeredSlides: false,
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 30,
                centeredSlides: false
            }
        },
        navigation: {
            nextEl: '.arrow-next',
            prevEl: '.arrow-prev',
        },
    });

    new Swiper('.media-journal-items-container', {
        slidesPerView: "auto",
        spaceBetween: 46,
        centeredSlides: false,
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 46,
                centeredSlides: false
            }
        },
        navigation: {
            nextEl: '.arrow-next',
            prevEl: '.arrow-prev',
        },
    });

    $(".product-form").submit(function (e) {
        e.preventDefault()

        let addToCartForm = this;
        let formData = new FormData(addToCartForm);

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
            .then(response => {
                var cartContents = fetch('/cart.js')
                    .then(response => response.json())
                    .then(data => {
                        $(".cart-button .cart-ico span.count").text("( " + data.item_count + " )")
                        $(".section-header__title span.count").text("( " + data.item_count + " )")
                        $("#overlay").addClass('opened')
                        $("section.cart").addClass('opened')
                        /*$("section.cart .item").each(function( index, val ) {

                            if( $(val).attr('data-pr_id') == data.items[index].id ) {
                                $(val).find(".pr_title_brand input").val(data.items[index].quantity)
                            }
                        });*/

                        return syncLegacyRvlFreeGift(data);
                    })
                    .then(function (data) {
                        updateOpenCartFromCartData(data);
                    });
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    })

    $(".cart-ico").click(function (e) {
        e.preventDefault()
        $("#open-nav").slideUp()
        $("#overlay").addClass('opened')
        $("section.cart").addClass('opened')
        refreshOpenCartDiscounts()
    })

    if ($("section.cart").length) {
        refreshOpenCartWithLegacyGift().catch(function () {});
    }

    if ($("#CartSection .cart__applied-discounts").length) {
        fetch("/cart.js")
            .then(function (response) {
                return response.json();
            })
            .then(function (cart) {
                updateAppliedDiscountCodes(cart);
            })
            .catch(function () {});
    }

    function formatCartMoney(cents) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
    }

    function normalizeDiscountCode(code) {
        return (code || "").trim().toLowerCase();
    }

    var legacyGiftSyncing = false;

    function getLegacyGiftConfig() {
        var $cart = $("section.cart");
        return {
            enabled: $cart.data("legacy-gift-enabled") === true,
            variantId: parseInt($cart.data("legacy-gift-variant-id"), 10),
            thresholdCents: parseInt($cart.data("legacy-gift-threshold-cents"), 10) || 40000,
            discountCode: ($cart.data("legacy-gift-discount-code") || "LEGACYRVL").toString()
        };
    }

    function isLegacyRvlGiftItem(item) {
        if (!item || !item.properties) {
            return false;
        }

        if (item.properties._legacy_rvl_gift) {
            return true;
        }

        if (Array.isArray(item.properties)) {
            return item.properties.some(function (property) {
                var key = property.name || property.first;
                return key === "_legacy_rvl_gift";
            });
        }

        return false;
    }

    function cartHasApplicableLegacyCode(cart, code) {
        if (!cart.discount_codes || !cart.discount_codes.length) {
            return false;
        }

        return cart.discount_codes.some(function (discount) {
            return discount.applicable && normalizeDiscountCode(discount.code) === normalizeDiscountCode(code);
        });
    }

    function getCartSubtotalExcludingLegacyGift(cart) {
        if (!cart.items || !cart.items.length) {
            return 0;
        }

        return cart.items.reduce(function (sum, item) {
            if (isLegacyRvlGiftItem(item)) {
                return sum;
            }

            return sum + (item.original_line_price || 0);
        }, 0);
    }

    function getOpenCartDisplaySubtotal(cart) {
        if (!cart.items || !cart.items.length) {
            return 0;
        }

        return cart.items.reduce(function (sum, item) {
            if (isLegacyRvlGiftItem(item)) {
                return sum;
            }

            return sum + (item.final_line_price || 0);
        }, 0);
    }

    function getOpenCartOriginalSubtotal(cart) {
        if (!cart.items || !cart.items.length) {
            return 0;
        }

        return cart.items.reduce(function (sum, item) {
            if (isLegacyRvlGiftItem(item)) {
                return sum;
            }

            return sum + (item.original_line_price || 0);
        }, 0);
    }

    function getCartLevelDiscountTotal(cart) {
        var itemsSubtotal = getOpenCartDisplaySubtotal(cart);
        return Math.max(0, itemsSubtotal - (cart.total_price || 0));
    }

    function getCartLevelDiscountPercent(cart) {
        var percent = 20;

        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            var discount = cart.cart_level_discount_applications[0];

            if (discount.value_type === "percentage" && discount.value) {
                percent = parseFloat(discount.value);
            }
        }

        return percent;
    }

    function getOpenCartCartLevelDiscountDisplayTotal(cart) {
        var itemsSubtotal = getOpenCartOriginalSubtotal(cart);
        return Math.round(itemsSubtotal * getCartLevelDiscountPercent(cart) / 100);
    }

    function getFallbackDiscountTitle(cart) {
        if (cart.discount_applications && cart.discount_applications.length) {
            for (var i = 0; i < cart.discount_applications.length; i++) {
                var title = getDiscountTitle(cart.discount_applications[i]);
                if (title) {
                    return title;
                }
            }
        }

        if (cart.discount_codes && cart.discount_codes.length) {
            for (var j = 0; j < cart.discount_codes.length; j++) {
                if (cart.discount_codes[j].applicable && cart.discount_codes[j].code) {
                    return cart.discount_codes[j].code;
                }
            }
        }

        return "Discount";
    }

    function getCartLevelDiscountRows(cart) {
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            return cart.cart_level_discount_applications.map(function (discount) {
                return {
                    title: getDiscountTitle(discount) || getFallbackDiscountTitle(cart),
                    amount: getCartLevelDiscountAmount(cart, discount)
                };
            });
        }

        var cartLevelTotal = getCartLevelDiscountTotal(cart);
        if (cartLevelTotal <= 0) {
            return [];
        }

        return [{
            title: getFallbackDiscountTitle(cart),
            amount: cartLevelTotal
        }];
    }

    function getOpenCartDiscountedSubtotal(cart) {
        var itemsSubtotal = getOpenCartDisplaySubtotal(cart);
        var originalSubtotal = getOpenCartOriginalSubtotal(cart);
        var discountedSubtotal = itemsSubtotal;
        var cartLevelDiscountTotal = getCartLevelDiscountTotal(cart);

        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            discountedSubtotal = originalSubtotal - getOpenCartCartLevelDiscountDisplayTotal(cart);
        } else if (cartLevelDiscountTotal > 0) {
            discountedSubtotal = originalSubtotal - cartLevelDiscountTotal;
        } else if (originalSubtotal > itemsSubtotal) {
            discountedSubtotal = itemsSubtotal;
        }

        return discountedSubtotal;
    }

    function buildOpenCartSubtotalPriceHtml(cart) {
        var itemsSubtotal = getOpenCartDisplaySubtotal(cart);
        var originalSubtotal = getOpenCartOriginalSubtotal(cart);
        var discountedSubtotal = getOpenCartDiscountedSubtotal(cart);

        if (originalSubtotal <= discountedSubtotal) {
            return '<span class="h5 cart__subtotal-price">' + formatCartMoney(itemsSubtotal) + '</span>';
        }

        return '<span class="cart__subtotal-prices">' +
            '<del class="h5 cart__subtotal-price">' + formatCartMoney(originalSubtotal) + '</del>' +
            '<span class="h5 cart__subtotal-price cart__subtotal-price--discounted">' + formatCartMoney(discountedSubtotal) + '</span>' +
            '</span>';
    }

    function cartQualifiesForLegacyGift(cart) {
        var config = getLegacyGiftConfig();

        if (!config.enabled || !config.variantId) {
            return false;
        }

        return cartHasApplicableLegacyCode(cart, config.discountCode) &&
            getOpenCartDiscountedSubtotal(cart) >= config.thresholdCents;
    }

    function findLegacyGiftLine(cart) {
        if (!cart.items || !cart.items.length) {
            return null;
        }

        return cart.items.find(isLegacyRvlGiftItem) || null;
    }

    function findOpenCartLineItem(lineKey) {
        if (!lineKey) {
            return $();
        }

        return $("section.cart .three_row .item").filter(function () {
            return $(this).attr("data-line-key") === lineKey;
        });
    }

    function sortOpenCartItems(cart) {
        var $container = $(".three_row");

        if (!$container.length || !cart.items || !cart.items.length) {
            return;
        }

        var visibleItems = cart.items.filter(function (item) {
            return !(isLegacyRvlGiftItem(item) && !cartQualifiesForLegacyGift(cart));
        });

        visibleItems.sort(function (a, b) {
            var aGift = isLegacyRvlGiftItem(a);
            var bGift = isLegacyRvlGiftItem(b);

            if (aGift && !bGift) {
                return -1;
            }

            if (!aGift && bGift) {
                return 1;
            }

            var titleA = (a.product_title || a.title || "").toLowerCase();
            var titleB = (b.product_title || b.title || "").toLowerCase();
            return titleA.localeCompare(titleB);
        });

        visibleItems.forEach(function (item) {
            var $item = findOpenCartLineItem(item.key);
            if ($item.length) {
                $container.append($item);
            }
        });
    }

    function buildOpenCartItemHtml(item) {
        var isGift = isLegacyRvlGiftItem(item);
        var imageUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : "";
        var priceHtml;

        if (isGift) {
            priceHtml = '<span class="h5">FREE</span>';
        } else if (item.original_line_price !== item.final_line_price) {
            priceHtml =
                '<del class="h5"><div class="un-line-item-total" data-id="' + item.key + '">' + formatCartMoney(item.original_line_price) + '</div></del>' +
                '<span class="order-discount h5">' + formatCartMoney(item.final_line_price) + '</span>';
        } else {
            priceHtml = '<span class="h5"><div class="un-line-item-total" data-id="' + item.key + '">' + formatCartMoney(item.original_line_price) + '</div></span>';
        }

        var qtyHtml = isGift
            ? '<small class="legacy-gift-qty">FREE GIFT</small>'
            : '<div class="qty">' +
                '<a class="qty-btn qty-minus" href="#"><span></span></a>' +
                '<input type="number" class="cart__quantity-selector" name="updates[]" id="updates_' + item.key + '" data-line-key="' + item.key + '" value="' + item.quantity + '" min="0" >' +
                '<a class="qty-btn qty-plus" href="#"><span></span></a>' +
                '</div>';

        return '<div class="item' + (isGift ? ' item--legacy-gift' : '') + '" data-line-key="' + item.key + '" data-variant-id="' + item.variant_id + '"' + (isGift ? ' data-legacy-gift="true"' : '') + '>' +
            '<a href="' + item.url + '" class="img">' +
            '<div class="pr_image">' +
            '<img src="' + imageUrl + '" alt="' + (item.title || "").replace(/"/g, "&quot;") + '">' +
            '</div></a>' +
            '<div class="pr_title_brand">' +
            '<a href="' + item.url + '" class="h5 cart__product-title">' + item.product_title + '</a>' +
            qtyHtml +
            '</div>' +
            '<div class="price_and_remove">' +
            '<div class="price">' + priceHtml + '</div>' +
            '<a href="#" class="cart__remove"></a>' +
            '</div></div>';
    }

    function appendMissingOpenCartItems(cart) {
        if (!cart.items || !cart.items.length) {
            return;
        }

        $(".empty-cart").hide();

        cart.items.forEach(function (item) {
            if (findOpenCartLineItem(item.key).length) {
                return;
            }

            $(".three_row").append(buildOpenCartItemHtml(item));
        });
    }

    function syncLegacyRvlFreeGift(cart) {
        if (legacyGiftSyncing) {
            return fetch("/cart.js").then(function (response) {
                return response.json();
            });
        }

        var config = getLegacyGiftConfig();
        var giftLine = findLegacyGiftLine(cart);

        if (!config.enabled) {
            if (!giftLine) {
                return Promise.resolve(cart);
            }

            legacyGiftSyncing = true;

            return fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: giftLine.key, quantity: 0 })
            })
                .then(function (response) {
                    return response.json().then(function (data) {
                        if (!response.ok) {
                            throw new Error(data.description || data.message || "Could not remove free gift.");
                        }

                        return data;
                    });
                })
                .finally(function () {
                    legacyGiftSyncing = false;
                });
        }

        if (!config.variantId) {
            return Promise.resolve(cart);
        }

        var qualifies = cartQualifiesForLegacyGift(cart);

        if (qualifies && !giftLine) {
            var variantAlreadyInCart = cart.items.some(function (item) {
                return item.variant_id === config.variantId && !isLegacyRvlGiftItem(item);
            });

            if (variantAlreadyInCart) {
                return Promise.resolve(cart);
            }

            legacyGiftSyncing = true;

            return fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    items: [{
                        id: config.variantId,
                        quantity: 1,
                        properties: { _legacy_rvl_gift: "true" }
                    }]
                })
            })
                .then(function (response) {
                    return response.json().then(function (data) {
                        if (!response.ok) {
                            throw new Error(data.description || data.message || "Could not add free gift.");
                        }

                        return fetch("/cart.js").then(function (cartResponse) {
                            return cartResponse.json();
                        });
                    });
                })
                .finally(function () {
                    legacyGiftSyncing = false;
                });
        }

        if (!qualifies && giftLine) {
            legacyGiftSyncing = true;

            return fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: giftLine.key, quantity: 0 })
            })
                .then(function (response) {
                    return response.json().then(function (data) {
                        if (!response.ok) {
                            throw new Error(data.description || data.message || "Could not remove free gift.");
                        }

                        return data;
                    });
                })
                .finally(function () {
                    legacyGiftSyncing = false;
                });
        }

        if (qualifies && giftLine && giftLine.quantity !== 1) {
            legacyGiftSyncing = true;

            return fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: giftLine.key, quantity: 1 })
            })
                .then(function (response) {
                    return response.json().then(function (data) {
                        if (!response.ok) {
                            throw new Error(data.description || data.message || "Could not update free gift.");
                        }

                        return data;
                    });
                })
                .finally(function () {
                    legacyGiftSyncing = false;
                });
        }

        return Promise.resolve(cart);
    }

    function refreshOpenCartWithLegacyGift() {
        return fetch("/cart.js")
            .then(function (response) {
                return response.json();
            })
            .then(function (cart) {
                return syncLegacyRvlFreeGift(cart);
            })
            .then(function (cart) {
                updateOpenCartFromCartData(cart);
                updateAppliedDiscountCodes(cart);
                return cart;
            });
    }

    function updateCartDiscount(discountValue) {
        return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ discount: discountValue })
        }).then(function (response) {
            return response.json().then(function (data) {
                if (!response.ok) {
                    throw new Error(data.description || data.message || "Could not update discount code.");
                }
                return data;
            });
        });
    }

    function updateAppliedDiscountCodes(cart) {
        var $containers = $(".cart__applied-discounts");
        $containers.empty();

        if (!cart.discount_codes || !cart.discount_codes.length) {
            return;
        }

        var discountHtml = "";
        cart.discount_codes.forEach(function (discount) {
            if (!discount.applicable) {
                return;
            }

            discountHtml +=
                '<div class="cart__applied-discount" style="display:flex; align-items:center; gap:13px; margin-top:10px; font-size:14px;">' +
                '<span class="cart__applied-discount-code">' + discount.code + '</span>' +
                '<button type="button" class="text-link remove-discount-code" data-discount-code="' + discount.code + '">Remove</button>' +
                '</div>';
        });

        if (discountHtml) {
            $containers.append(discountHtml);
        }
    }

    function getRemainingDiscountCodes(cart, codeToRemove) {
        if (!cart.discount_codes || !cart.discount_codes.length) {
            return "";
        }

        return cart.discount_codes
            .filter(function (discount) {
                return discount.applicable && normalizeDiscountCode(discount.code) !== normalizeDiscountCode(codeToRemove);
            })
            .map(function (discount) {
                return discount.code;
            })
            .join(",");
    }

    function refreshOpenCartDiscounts() {
        refreshOpenCartWithLegacyGift().catch(function () {});
    }

    function getDiscountTitle(discount) {
        return discount.title || discount.description || discount.code || "";
    }

    function getCartLevelDiscountAmount(cart, discount) {
        var cartLevelDiscountTotal = getOpenCartCartLevelDiscountDisplayTotal(cart);

        if (!cart.cart_level_discount_applications || cart.cart_level_discount_applications.length <= 1) {
            if (discount && discount.value_type === "percentage" && discount.value) {
                return Math.round(getOpenCartOriginalSubtotal(cart) * parseFloat(discount.value) / 100);
            }

            return cartLevelDiscountTotal;
        }

        if (discount && discount.total_allocated_amount > 0) {
            return discount.total_allocated_amount;
        }

        return Math.round(cartLevelDiscountTotal / cart.cart_level_discount_applications.length);
    }

    function getCartLineKey($input) {
        return $input.attr("data-line-key") || ($input.attr("id") || "").replace("updates_", "");
    }

    function setCartLineKey($input, lineKey) {
        $input.attr("data-line-key", lineKey).attr("id", "updates_" + lineKey);
    }

    function isCartPage() {
        return /^\/cart\/?$/.test(window.location.pathname);
    }

    function updateCartLineQuantity($input) {
        if ($input.data("updating")) {
            return Promise.resolve();
        }

        var lineKey = getCartLineKey($input);
        var quantity = parseInt($input.val(), 10);

        if (!lineKey) {
            return Promise.resolve();
        }

        if (isNaN(quantity) || quantity < 0) {
            quantity = 0;
            $input.val(0);
        }

        $input.data("updating", true);
        $input.closest(".qty").find(".qty-btn").addClass("disabled");

        return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: lineKey, quantity: quantity })
        })
            .then(function (response) {
                return response.json().then(function (data) {
                    if (!response.ok) {
                        throw new Error(data.description || data.message || "Could not update cart.");
                    }
                    return data;
                });
            })
            .then(function (cart) {
                return syncLegacyRvlFreeGift(cart);
            })
            .then(function (cart) {
                if (isCartPage()) {
                    window.location.reload();
                    return cart;
                }

                updateOpenCartFromCartData(cart);
                return cart;
            })
            .catch(function (error) {
                console.error("Error:", error);
                refreshOpenCartDiscounts();
            })
            .finally(function () {
                $input.data("updating", false);
                $input.closest(".qty").find(".qty-btn").removeClass("disabled");
            });
    }

    function updateOpenCartFromCartData(cart) {
        $(".cart__discount-message").hide().text("");

        $(".cart-button .cart-ico span.count").text("( " + cart.item_count + " )");
        $(".section-header__title span.count").text("( " + cart.item_count + " )");

        var cartLineKeys = {};

        if (cart.items && cart.items.length) {
            $(".empty-cart").hide();

            cart.items.forEach(function (item) {
                if (isLegacyRvlGiftItem(item) && !cartQualifiesForLegacyGift(cart)) {
                    return;
                }

                cartLineKeys[item.key] = true;

                var $item = findOpenCartLineItem(item.key);
                if (!$item.length) {
                    $(".three_row").append(buildOpenCartItemHtml(item));
                    $item = findOpenCartLineItem(item.key);
                }

                if (!$item.length) {
                    return;
                }

                var $input = $item.find(".pr_title_brand input.cart__quantity-selector");
                if ($input.length) {
                    $input.val(item.quantity);
                    setCartLineKey($input, item.key);
                }

                var $price = $item.find(".price_and_remove .price");
                if (isLegacyRvlGiftItem(item)) {
                    $price.html('<span class="h5">FREE</span>');
                    $item.addClass("item--legacy-gift").attr("data-legacy-gift", "true");
                } else {
                    $item.removeClass("item--legacy-gift").removeAttr("data-legacy-gift");
                    if (item.original_line_price !== item.final_line_price) {
                        $price.html(
                            '<del class="h5"><div class="un-line-item-total" data-id="' + item.key + '">' + formatCartMoney(item.original_line_price) + '</div></del>' +
                            '<span class="order-discount h5">' + formatCartMoney(item.final_line_price) + '</span>'
                        );
                    } else {
                        $price.html('<span class="h5"><div class="un-line-item-total" data-id="' + item.key + '">' + formatCartMoney(item.original_line_price) + '</div></span>');
                    }
                }
            });
        }

        $("section.cart .three_row .item").each(function () {
            var lineKey = $(this).attr("data-line-key");
            if (!lineKey || !cartLineKeys[lineKey]) {
                $(this).remove();
            }
        });

        if (cart.item_count === 0) {
            $(".empty-cart").show();
            $(".cart__discount-code").hide();
        } else {
            $(".empty-cart").hide();
            $(".cart__discount-code").show();
        }

        var $subtotal = $("section.cart .cart__subtotal");
        $subtotal.find(".order-discount-cart-wrapper").remove();

        var discountRows = getCartLevelDiscountRows(cart);
        if (discountRows.length > 0) {
            var discountHtml = '<div class="order-discount-cart-wrapper">';
            discountRows.forEach(function (discount) {
                discountHtml +=
                    '<span class="order-discount order-discount--title order-discount--cart">' +
                    '<span class="icon icon-saletag" aria-hidden="true"></span>' + discount.title + '</span>' +
                    '<span class="order-discount order-discount--cart"><strong>-' + formatCartMoney(discount.amount) + '</strong></span>';
            });
            discountHtml += '</div>';
            $subtotal.prepend(discountHtml);
        }

        $(".subtotal_bottom .cart__subtotal-price-wrapper").html(buildOpenCartSubtotalPriceHtml(cart));
        updateAppliedDiscountCodes(cart);
        sortOpenCartItems(cart);
    }

    function cartHasDiscount(cart) {
        if (cart.total_discount > 0) {
            return true;
        }

        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            return true;
        }

        return cart.items.some(function (item) {
            return item.total_discount > 0 || (item.discounts && item.discounts.length > 0);
        });
    }

    function getCartDiscountCode(cart, code) {
        if (!cart.discount_codes || !cart.discount_codes.length) {
            return null;
        }

        var normalizedCode = normalizeDiscountCode(code);
        return cart.discount_codes.find(function (entry) {
            return normalizeDiscountCode(entry.code) === normalizedCode;
        }) || null;
    }

    function getDiscountApplicationResult(cart, code) {
        var discountEntry = getCartDiscountCode(cart, code);

        if (discountEntry && discountEntry.applicable) {
            return { status: "applied", message: "Discount applied." };
        }
        if (discountEntry && !discountEntry.applicable) {
            if (normalizeDiscountCode(code) === normalizeDiscountCode(getLegacyGiftConfig().discountCode)) {
                var legacyGiftConfig = getLegacyGiftConfig();
                return {
                    status: "invalid",
                    message: "This discount will only apply on orders above $200."
                };
            }

            return {
                status: "invalid",
                message: "This discount code does not exist or is not valid for the items in your cart."
            };
        }

        if (cartHasDiscount(cart)) {
            return { status: "applied", message: "Discount applied." };
        }

        return {
            status: "invalid",
            message: "This discount code does not exist or is not valid for the items in your cart."
        };
    }

    $("body").on("click", ".apply-discount-code", function (e) {
        e.preventDefault();

        var $button = $(this);
        var $container = $button.closest(".cart__discount-code");
        var code = $container.find('input[name="discount"]').val().trim();
        var $message = $container.find(".cart__discount-message");

        $button.prop("disabled", true);
        $message.hide();

        if (!code) {
            $message.text("Enter a discount code.").css("color", "#c0392b").show();
            $button.prop("disabled", false);
            return;
        }

        updateCartDiscount(code)
            .then(function (cart) {
                return syncLegacyRvlFreeGift(cart);
            })
            .then(function (cart) {
                if (isCartPage()) {
                    window.location.reload();
                    return cart;
                }

                updateOpenCartFromCartData(cart);

                var result = getDiscountApplicationResult(cart, code);
                if (result.status === "applied") {
                    $message.text(result.message).css("color", "#2e7d32").show();
                } else {
                    $message.text(result.message).css("color", "#c0392b").show();
                }
            })
            .catch(function (error) {
                $message.text(error.message || "Could not apply discount code.").css("color", "#c0392b").show();
            })
            .finally(function () {
                $button.prop("disabled", false);
            });
    });

    $("body").on("click", "section.cart .qty-minus", function (e) {
        e.preventDefault();

        var $input = $(this).closest(".qty").find(".cart__quantity-selector");
        $input[0].stepDown();
        updateCartLineQuantity($input);
    });

    $("body").on("click", "section.cart .qty-plus", function (e) {
        e.preventDefault();

        var $input = $(this).closest(".qty").find(".cart__quantity-selector");
        $input[0].stepUp();
        updateCartLineQuantity($input);
    });

    $("body").on("change", "section.cart .cart__quantity-selector", function () {
        updateCartLineQuantity($(this));
    });

    $("body").on("click", "section.cart .cart__remove", function (e) {
        e.preventDefault();

        var $input = $(this).closest(".item").find(".cart__quantity-selector");
        $input.val(0);
        updateCartLineQuantity($input);
    });

    function proceedOpenCartCheckout($button) {
        var $discountContainer = $("section.cart .cart__discount-code");
        var code = $discountContainer.find('input[name="discount"]').val().trim();
        var $message = $discountContainer.find(".cart__discount-message");

        $button.prop("disabled", true);
        $message.hide();

        var checkoutPromise = code
            ? updateCartDiscount(code)
            : Promise.resolve(null);

        checkoutPromise
            .then(function (cart) {
                if (!cart) {
                    return fetch("/cart.js").then(function (response) {
                        return response.json();
                    });
                }

                return cart;
            })
            .then(function (cart) {
                return syncLegacyRvlFreeGift(cart);
            })
            .then(function (cart) {
                if (code) {
                    var result = getDiscountApplicationResult(cart, code);
                    if (result.status !== "applied") {
                        $message.text(result.message).css("color", "#c0392b").show();
                        return;
                    }
                }

                window.location.href = "/checkout";
            })
            .catch(function (error) {
                $message.text(error.message || "Could not proceed to checkout.").css("color", "#c0392b").show();
            })
            .finally(function () {
                $button.prop("disabled", false);
            });
    }

    $("body").on("click", 'section.cart [name="checkout"]', function (e) {
        e.preventDefault();

        if (!$("#agree").is(":checked")) {
            alert("You must agree with the terms and conditions of sales to check out.");
            return false;
        }

        proceedOpenCartCheckout($(this));
    });

    $("body").on("click", ".remove-discount-code", function (e) {
        e.preventDefault();

        var $button = $(this);
        var $container = $button.closest(".cart__discount-code");
        var codeToRemove = $button.data("discount-code");
        var $message = $container.find(".cart__discount-message");
        var $input = $container.find('input[name="discount"]');

        $button.prop("disabled", true);
        $message.hide();

        fetch("/cart.js")
            .then(function (response) {
                return response.json();
            })
            .then(function (cart) {
                var remainingCodes = getRemainingDiscountCodes(cart, codeToRemove);
                return updateCartDiscount(remainingCodes);
            })
            .then(function (cart) {
                return syncLegacyRvlFreeGift(cart);
            })
            .then(function (cart) {
                if (isCartPage()) {
                    window.location.reload();
                    return cart;
                }

                updateOpenCartFromCartData(cart);

                if (normalizeDiscountCode($input.val()) === normalizeDiscountCode(codeToRemove)) {
                    $input.val("");
                }

                $message.text("Discount removed.").css("color", "#2e7d32").show();
            })
            .catch(function (error) {
                $message.text(error.message || "Could not remove discount code.").css("color", "#c0392b").show();
            })
            .finally(function () {
                $button.prop("disabled", false);
            });
    });

    $("button.close_cart").click(function (e) {
        e.preventDefault()
        $("#overlay").removeClass('opened')
        $("section.cart").removeClass('opened')
    })

    $("#popup_trigger_virtually").trigger('click')
    $("#popup_book_in_virtually .check").click(function () {
        $(this).toggleClass('checked')
        if ($(this).hasClass('checked')) {
            $("#virtually_button").attr('disabled', false)
        } else {
            $("#virtually_button").attr('disabled', true)
        }
    })
    const first_order = window.localStorage.getItem('first_order');
    //const cookieConfirmed = window.localStorage.getItem('cookieConfirm');
    if (!first_order) {
        $("#popup_trigger_first_order").trigger('click')
        //$.cookie("first_order", "1", { path: '/' });
        window.localStorage.setItem('first_order', true);
        $("#first_order_email").validate({
            rules: {
                email_field: {
                    required: true,
                    email: true
                }
            },
            submitHandler: function (form, e) {
                e.preventDefault();
            },
        });
        $("#first_order_email input").keyup(function () {
            if ($(this).val() != "") {
                $("#first_order_button").attr('disabled', false)
            }
        })
        $("#first_order_email").submit(function (e) {
            if ($(this).find('input').hasClass('error')) {
                $("#first_order_button").attr('disabled', true)
            } else {
                let first_order_email = $(this).find('input').val()
                $.ajax({
                    type: "POST",
                    url: "https://app-web.rvlskincare.com/first_order.php",
                    data: {
                        first_order_email, action: "first_order"
                    },
                    success: function (res) {
                        if (res != "error") {
                            $("#first_order_email").hide()
                            $(".thank-you").show()
                        }
                    },
                    error: function () {
                        $('.error-message').show();
                    }
                });
            }

        })
    }

    $("#pwd_established .input_pwd").keyup(function (e) {
        $(".thank-you").hide()
        if ($(this).val().length > 3) {
            $("#pwd_established #first_order_button").removeAttr('disabled')
        } else {
            $("#pwd_established #first_order_button").attr('disabled', true)
        }
    })

    $("#pwd_established").submit(function (e) {
        e.preventDefault()
        let pwd = $(".input_pwd").val()
        if (pwd.toLowerCase() == "collagen") {
            $.fancybox.close();
            window.location.replace('https://bwh9n60tfltc7t24-11067949152.shopifypreview.com/products_preview?preview_key=e55c91c14c978ca2b8145fb362199a42')
            /*$(".left-side").hide()
            $(".patients").hide()
            $(".first_step_form").hide()
            $(".second_step_form").hide()
            $(".three_step_form").hide()
            $("#__ezderm_online_scheduling_widget__ h2").show()
            $("#__ezderm_online_scheduling_widget__").show()
            $(".services").slideDown({
                start: function () {
                    if ($(window).width() > 767) {
                        $(this).css({
                            display: "flex"
                        })
                        $(this).find(".right-side").css({"max-width": "100%"})
                    } else {
                        $(this).css({
                            display: "block"
                        })
                        $(this).find(".right-side").css({"max-width": "100%"})
                    }
                }
            })*/
        } else {
            $(".thank-you").slideDown()
        }
    })
    // rvl-skincare-pc PAGE
    $("#concierge .label, #concierge .item span.established, #concierge span.new, #concierge span.check, span.confirm, .confirm_row label").on("click touchstart", function (e) {
        let elem = null

        if ($(this).hasClass('label')) {
            elem = $(this).prev()
        } else {
            elem = $(this)
        }

        $("#concierge .form .item span.established, #concierge .form .item span.new").removeClass('error')

        if (elem.hasClass('established') || elem.hasClass('confirm')) {
            if (!elem.hasClass('checked')) {
                $('span.new').removeClass('checked')
                if ($("#sendMemberForm #full_name_input").val() !== "" && $("#sendMemberForm #date").val() !== "") {
                    $(elem).addClass('checked')
                    if($("form#sendMemberForm .confirm_row span.checked").length > 1)
                      $(".btn-membership").attr('disabled', false)
                } else {
                    if ($("#sendMemberForm #full_name_input").val() === "") {
                        $("#sendMemberForm #full_name_input").css({"border-bottom": "1px solid red"})
                    } else {
                        $("#sendMemberForm #full_name_input").css({"border-bottom": "1px solid #000"})
                    }
                    if ($("#sendMemberForm #date").val() === "") {
                        $("#sendMemberForm #date").css({"border-bottom": "1px solid red"})
                    } else {
                        $("#sendMemberForm #date").css({"border-bottom": "1px solid #000"})
                    }
                }
                /*$(".password_popup").removeClass('hide')*/
            }
        } else {
            /*$(".password_popup").addClass('hide')*/
            $('span.established').removeClass('checked')
            $(elem).addClass('checked')
        }

        if ($("form span.checked").length > 1) {
            $("form.form button.continue").attr('disabled', false)
        }
    })

    let today = new Date(),
        month = new Date().toLocaleString('en-EN', {month: 'long'}),
        date = month + ' ' + today.getDate() + ", " + today.getFullYear()

    $(".nowDateContract").text(date)

    $("#sendMemberForm #full_name_input, #sendMemberForm #date").on("keyup", function (e) {
        if ($(e.target).attr('id') === "full_name_input") {
            if ($(this).val() === "") {
                $(this).css({"border-bottom": "1px solid red"})
            } else {
                $(this).css({"border-bottom": "1px solid #000"})
            }
        } else {
            if ($(this).val() === "") {
                $(this).css({"border-bottom": "1px solid red"})
            } else {
                $(this).css({"border-bottom": "1px solid #000"})
            }
        }
    })

    $("#sendMemberForm").submit(e => {
        e.preventDefault()
        if (isEmpty(parameters) == false) {
            let variant_id = ''
            $.each(parameters, function (key, value) {
                if (key == "portal_app" && value != "") {
                    // first
                    $("#sendMemberForm .btn-membership").attr("disabled", false)
                    variant_id = value
                }
                if (key == 'contract_id' && value != "") {
                    let redUrl = `https://rvlskincare.com/cart/add?items[0][id]=${variant_id}&items[0][quantity]=1&items[0][properties][_id]=${value}`
                    window.location.replace(redUrl)
                    return false
                }

                if (key == "url" && value != "") {
                    let full_name = $("#full_name_input").val(),
                        date = $("#sendMemberForm #date").val()

                    $.ajax({
                        type: "POST",
                        url: "https://app-web.rvlskincare.com/contract.php",
                        data: {
                            full_name, date, amountContract
                        },
                        beforeSend: function () {
                            $("#sendMemberForm .btn-membership").attr("disabled", true)
                        },
                        success: function (res) {
                            $("#sendMemberForm .btn-membership").attr("disabled", false)
                            console.log("***********1182")
                            window.location.href = value
                        },
                        error: function () {
                            $('.error-message').show();
                        }
                    })

                }
            });
        }
    })
    const ninjaValidateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    function NinjaValidateName(full_name) {
        let regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
        if (!regName.test(full_name.val())) {
            $(full_name).css({"border-bottom": "1px solid red"}).focus()
            return false
        } else {
            $(full_name).css({"border-bottom": "1px solid #040e1c"})
            return true
        }
    }

    // Established Patient -- DONE!
    $("#concierge form").submit(function (e) {
        e.preventDefault()
        let typePatient = $("#concierge .form .item span.checked").attr('data-type')
        if (typePatient != undefined) {
            let full_name = $("#full_name_popup"),
                email = $("#email_popup")
            if (typePatient == "established_patient") {
                if (NinjaValidateName(full_name) && ninjaValidateEmail(email.val())) {
                    // if(NinjaValidateName(full_name)) full_name.css({"border-bottom": "1px solid red"})
                    // else full_name.css({"border-bottom": "1px solid #040e1c"})
                    if (!ninjaValidateEmail(email.val())) email.css({"border-bottom": "1px solid red"})
                    else email.css({"border-bottom": "1px solid #040e1c"})

                    $.ajax({
                        type: "POST",
                        url: "https://app.rvlskincare.com/api/concierge-care-mail",
                        beforeSend: function(request) {
                          request.setRequestHeader("Content-Type", 'application/json');
                          request.setRequestHeader("Accept", 'application/json');
                          $("#concierge button.continue").attr('disabled', true)
                        },
                        data: JSON.stringify({
                            full_name: full_name.val(),
                            email: email.val(),
                            typePatient
                        }),
                        success: function (res) {
                            $.fancybox.close()
                            $.fancybox.open({
                                src: '#thank_you_established',
                                type: 'inline',
                                modal: true,
                                smallBtn: true,
                                buttons: ["close"]
                            })
                            $("#thank_you_established").css({"display": "inline-flex"})
                            $("#concierge button.continue").attr('disabled', false)
                        },
                        error: function () {
                            $('.error-message').show();
                        }
                    })
                } else {
                    // if(NinjaValidateName(full_name.val())) full_name.css({"border-bottom": "1px solid red"})
                    // else full_name.css({"border-bottom": "1px solid #040e1c"})
                    if (!ninjaValidateEmail(email.val())) email.css({"border-bottom": "1px solid red"})
                    else email.css({"border-bottom": "1px solid #040e1c"})
                }
            } else {
                if (NinjaValidateName(full_name) && ninjaValidateEmail(email.val())) {
                    $.fancybox.close()
                    $.fancybox.open({
                        src: '#concierge_new_patient',
                        type: 'inline',
                        modal: true,
                        smallBtn: true,
                        buttons: ["close"]
                    })
                } else {
                    // if(!NinjaValidateName(full_name.val())) full_name.css({"border-bottom": "1px solid red"})
                    // else full_name.css({"border-bottom": "1px solid #040e1c"})
                    if (!ninjaValidateEmail(email.val())) email.css({"border-bottom": "1px solid red"})
                    else email.css({"border-bottom": "1px solid #040e1c"})
                }
            }
        } else {
            $("#concierge .form .item span.established, #concierge .form .item span.new").addClass('error')
        }
    })

    // Request an appointment (Aspen) — concierge-care-mail API (typePatient mirrors established concierge)
    $("#RequestAppointmentContactForm").on("submit", function (e) {
        e.preventDefault()
        var $form = $(this)
        var $submit = $form.find("button.request-appointment-main__submit")
        var $err = $form.find(".error-message").hide().text('')
        var full_name = $("#RequestAppointmentName")
        var email = $("#RequestAppointmentEmail")
        var dob = $("#RequestAppointmentDob")
        var phone = $("#RequestAppointmentPhone")
        var hipaaChecked = $("#RequestAppointmentHipaa").is(":checked")

        $(".request-appointment-hipaa").removeClass("error")

        var dobVal = (dob.val() || "").trim()
        var dobOk = dobVal.length === 10

        var phoneVal = (phone.val() || "").trim()
        var phoneOk = phoneVal.replace(/\D/g, "").length >= 10

        var emailVal = (email.val() || "").trim()
        var emailOk = !!ninjaValidateEmail(emailVal)

        var regNameAspen = /^[a-zA-Z]+ [a-zA-Z]+$/
        var nameOk = regNameAspen.test((full_name.val() || "").trim())

        dob.css({"border-bottom": dobOk ? "1px solid #040e1c" : "1px solid red"})
        phone.css({"border-bottom": phoneOk ? "1px solid #040e1c" : "1px solid red"})
        $(email).css({"border-bottom": emailOk ? "1px solid #040e1c" : "1px solid red"})
        full_name.css({"border-bottom": nameOk ? "1px solid #040e1c" : "1px solid red"})

        var formOk = hipaaChecked && dobOk && phoneOk && nameOk && emailOk
        if (!hipaaChecked) {
            $(".request-appointment-hipaa").addClass("error")
        }

        if (!formOk) {
            return
        }

        $.ajax({
            type: "POST",
            url: "https://app.rvlskincare.com/api/concierge-care-mail",
            beforeSend: function (request) {
                request.setRequestHeader("Content-Type", "application/json")
                request.setRequestHeader("Accept", "application/json")
                $submit.prop("disabled", true)
            },
            data: JSON.stringify({
                full_name: (full_name.val() || "").trim(),
                email: emailVal,
                typePatient: "established_patient",
                date_of_birth: dobVal,
                phone: phoneVal,
                hipaa_acknowledgment: "Acknowledged",
                notes: "Request an appointment — Aspen new patient form submission"
            }),
            success: function () {
                var rootUrl = $form.attr("data-root-url") || "/"
                $.fancybox.open({
                    src: "#thank_you_request_appointment",
                    type: "inline",
                    opts: {
                        modal: true,
                        smallBtn: true,
                        buttons: ["close"],
                        afterClose: function () {
                            window.location.href = rootUrl
                        }
                    }
                })
                $("#thank_you_request_appointment").css({ display: "inline-flex" })
                $submit.prop("disabled", false)
            },
            error: function () {
                $err.text("Something went wrong. Please try again.").show()
                $submit.prop("disabled", false)
            }
        })
    })

    // send email - pending...
    $("#concierge_pwd form").submit(function (e) {
        e.preventDefault()
        const pwdArr = []
        let full_name = $("#concierge_fullName"),
            password = $("#concierge_password"),
            type = null
        $("#shopify-section-password-section span, #shopify-section-password-section-page span").map((index, elem) => {
            let pwd = $(elem).attr('data-cont_pwd'),
                pr_url = $(elem).attr('data-pr_id'),
                type = $(elem).attr('data-type'),
                amount = $(elem).attr('data-amount'),
                amount_text = $(elem).attr('data-amount_text')
            pwdArr.push({key: pwd, url: pr_url, type, amount, amount_text})
        })

        const checkPwd = pwdArr.find(e => e.key === password.val().toLowerCase()) || null

        if (full_name && checkPwd) {
            $("#concierge_password").css({"border-bottom": "1px solid #040e1c"})
            if (checkPwd.type == "page") {
                window.location.href = checkPwd.url
            } else {
                window.location.href = `/pages/established-contract?fullName=${full_name.val().replace(' ', '+')}&url=${checkPwd.url}&amount=${checkPwd.amount}&amount_text=${checkPwd.amount_text.replaceAll(' ', '+')}&amount_discounted=`
            }
        } else {
            $("#concierge_password").css({"border-bottom": "1px solid red"})
        }
    })

    // New Patient -- DONE!
    $("#concierge_new_patient form").submit(e => {
        e.preventDefault()
        let full_name = $("#full_name_popup").val(),
            email = $("#email_popup").val(),
            location = $(".locationConcierge span.selected").attr('data-value'),
            reason = $(".reasonConcierge span.selected").attr('data-value'),
            typePatient = 'new_patient'

        $.ajax({
            type: "POST",
            url: "https://app.rvlskincare.com/api/concierge-care-mail",
            data: JSON.stringify({full_name, email, location, reason, typePatient}),
            beforeSend: function (request) {
                $("#concierge_new_patient button.continue").attr('disabled', true);
                request.setRequestHeader("Content-Type", 'application/json');
                request.setRequestHeader("Accept", 'application/json');
            },
            success: function (res) {
                $("#concierge_new_patient").css({"display": "inline-flex"})
                $("#concierge_new_patient h3").text("Thank you!")
                $("#concierge_new_patient button#closePopup").removeClass("hide")
                $("#concierge_new_patient .thankYouText").removeClass("hide")
                $("#concierge_new_patient form").remove()
                $("#concierge_new_patient button.continue").attr('disabled', false)
            },
            error: function () {
                $('.error-message').show();
            }
        })
    })

    $(".services span.back").click(function (e) {
        $(".services").slideUp()
        $(".concierge").slideDown()
    })

    if ($("body#create-account:not(.template-customers-activate_account)").length > 0) {
        window.location.replace('https://rvlskincare.com/account/login')
    }

})